module.exports = __webpack_public_path__ + "cu.svg?1c7cc4da857495d8b44eb88d22a51e33";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/cu.svg
// module id = 1055
// module chunks = 0